// The name a chat is listed under. Chats made before titles existed only
// have their first message.
export const taskTitle = (task) =>
  task?.title || task?.task_description || 'New chat';

// Put a title that arrived later (the generated one) on its chat, leaving
// the order of the list alone.
export const withTaskTitle = (tasks, taskId, title) =>
  title
    ? tasks.map((task) => (task._id === taskId ? { ...task, title } : task))
    : tasks;
